export default "__VITE_ASSET__ce04d0f8__"